export const MEDIA_MANAGEMENT_BASE = '/media-management';

export const mediaManagementPaths = {
  root: MEDIA_MANAGEMENT_BASE,
  location: `${MEDIA_MANAGEMENT_BASE}/location`,
  items: `${MEDIA_MANAGEMENT_BASE}/items`,
} as const;
